import React, { useEffect } from 'react';
import Navbar from '../components/site/Navbar';
import Hero from '../components/site/Hero';
import Marquee from '../components/site/Marquee';
import TrustBadges from '../components/site/TrustBadges';
import About from '../components/site/About';
import Pathways from '../components/site/Pathways';
import Programs from '../components/site/Programs';
import Included from '../components/site/Included';
import Team from '../components/site/Team';
import Journey from '../components/site/Journey';
import Services from '../components/site/Services';
import Testimonials from '../components/site/Testimonials';
import Insights from '../components/site/Insights';
import FAQ from '../components/site/FAQ';
import Gym from '../components/site/Gym';
import Newsletter from '../components/site/Newsletter';
import BookingForm from '../components/site/BookingForm';
import Footer from '../components/site/Footer';

const Landing = () => {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="bg-cream min-h-screen">
      <Navbar />
      <div className="pt-20">
        <Marquee />
      </div>
      <Hero />
      <About />
      <Pathways />
      <Programs />
      <Included />
      <Team />
      <Journey />
      <Services />
      <Testimonials />
      <FAQ />
      <Gym />
      <Newsletter />
      <BookingForm />
      <Footer />
    </div>
  );
};

export default Landing;
